import Button from "~/components/ui/Button";
import Icon from "~/components/ui/Icon";
import Modal from "~/components/ui/Modal";
import Slider from "~/components/ui/Slider";
import SliderJS from "~/components/ui/SliderJS";
import { useId } from "react";
import { useSignal } from "~/sdk/signal";
import Image from "~/components/ui/Image";
import { getProductImageAlt } from "~/utils/product";

interface ZoomImage {
  url?: string;
  alternateName?: string;
}

export interface Props {
  images: ZoomImage[];
  width: number;
  height: number;
  productName?: string | null;
}

function ProductImageZoom({ images, width, height, productName }: Props) {
  const id = useId();
  const open = useSignal(false);

  if (!images) {
    return null;
  }

  return (
    <>
      <Button
        className="hidden btn-ghost"
        onClick={() => (open.value = true)}
        aria-label="Zoom"
      >
        <Icon id="Zoom" size={24} />
      </Button>
      <div id={id}>
        <Modal
          loading="lazy"
          open={open.value}
          onClose={() => (open.value = false)}
        >
          <div className="modal-box w-11/12 max-w-7xl grid grid-cols-[48px_1fr_48px] grid-rows-1 place-items-center">
            <Slider className="carousel col-span-full col-start-1 row-start-1 row-span-full h-full w-full">
              {images?.map((image, index) => {
                const imageAlt = getProductImageAlt(productName, index);
                return (
                  <Slider.Item
                    index={index}
                    className="carousel-item w-full h-full justify-center items-center"
                  >
                    <Image
                      style={{ aspectRatio: `${width} / ${height}` }}
                      src={image.url!}
                      alt={imageAlt}
                      width={width}
                      height={height}
                      className="h-full w-auto"
                      loading="lazy"
                      fetchPriority="low"
                      decoding="async"
                    />
                  </Slider.Item>
                );
              })}
            </Slider>

            <Slider.PrevButton className="btn btn-circle btn-outline col-start-1 col-end-2 row-start-1 row-span-full">
              <Icon size={24} id="ChevronLeft" strokeWidth={3} />
            </Slider.PrevButton>

            <Slider.NextButton className="btn btn-circle btn-outline col-start-3 col-end-4 row-start-1 row-span-full">
              <Icon size={24} id="ChevronRight" strokeWidth={3} />
            </Slider.NextButton>

            <SliderJS rootId={id} />
          </div>
        </Modal>
      </div>
    </>
  );
}

export default ProductImageZoom;
